import FormStep from "./FormStep";
import Vue, { CreateElement } from "vue";
import EventWaiverModel, { create as createWaiver } from "../../models/EventWaiverModel";
import { Component, Prop } from "vue-property-decorator";
import matchAll from "string.prototype.matchall";
import EventEntryModel from "../../models/EventEntryModel";
import { VNode } from "vue/types/vnode";

matchAll.shim();

function parsePlaceholderValue(s: string): string {
  if (s === undefined) return '';

  if (s.indexOf('name') === 0 || s.indexOf('placeholder') === 0) {
    return s;
  }

  if (s === 'required') {
    return s;
  }

  if (['small', 'medium', 'large'].indexOf(s) > -1) {
    return 'waiver-input--' + s;
  }

  return s;
}

function isClassValue(s: string): boolean {
  if (s === undefined) return false;

  if (['small', 'medium', 'large'].indexOf(s) > -1) {
    return true;
  }

  return false;
}

function makeEditable(content: string, values: Record<string, string> = {}): [string[], string[], string] {
  const reg = /\[(text|checkbox)\s(name=["][^"\s]+["])\s?(placeholder=["].+["])?\s?([^\s\]]+)?\s?\s?([^\s\]]+)?\s?]/g;
  const matches = [...content.matchAll(reg)];

  const required = [];
  const names = [];
  for (const m of matches) {
    let inputName = m[2].substr(6);
    inputName = inputName.substr(0, inputName.length -1);
    names.push(inputName);

    const rep = ['<'];
    rep.push(m[1] == 'text' ? 'input type="text" ' : 'input type="checkbox" ');

    const classes = ['waiver-input'];

    for (let i = 2; i < m.length; i++) {
      if (isClassValue(m[i])) {
        classes.push(parsePlaceholderValue(m[i]));
      } else {
        rep.push(parsePlaceholderValue(m[i]));
      }
    }

    rep.push(`class="${classes.join(' ')}" :class="requiredClass('${inputName}')"`)
    rep.push('@change="inputChanged"')

    if (rep.indexOf('required') > -1) {
      required.push(inputName);
    }

    rep.push(`v-model="values.${inputName}"`);
    content = content.replace(m[0], rep.shift() + rep.join(' ') + '>');
  }

  return [required, names, content];
}

// function makeViewable(content: string, values: string[]): string {
//   const reg = /\[(text|checkbox)\s+name=["']([\w_]+)["']\s?(required)?]/g;
//   const matches = [...content.matchAll(reg)];
//
//   return content;
// }

@Component
export default class CustomWaiverStep extends Vue {
  @Prop() defaultWaiver!: EventWaiverModel;
  @Prop() entry!: EventEntryModel;

  waiver!: EventWaiverModel;
  values!: Record<string, string>;
  required!: Record<string, boolean>;

  compiledTemplate!: ReturnType<typeof Vue.compile>

  created(): void {
    const prep = makeEditable(this.waiver.data.content, this.values);

    for (const req of prep[0]) {
      this.$set(this.required, req, this.values[req] ? true : false);
    }
    for (const n of prep[1]) {
      if (!this.values[n]) {
        this.$set(this.values, n, "");
      }
    }

    this.$emit('valid', this.waiverIsValid());

    this.compiledTemplate = Vue.compile('<div class="waiver">' + prep[2] + '</div>');
  }

  data(): {waiver: EventWaiverModel, values: Record<string,string>, required: Record<string, boolean>} {
    const waiver = createWaiver(JSON.parse(JSON.stringify(this.defaultWaiver.data)));
    waiver.data.id = 0;
    waiver.data.entry_ref = this.entry.data.reference;

    return {
      waiver,
      values: this.entry.waiver?.data.fields ? JSON.parse(JSON.stringify(this.entry.waiver.data.fields)) : {},
      required: {},
    }
  }

  requiredClass(fieldName: string): string {
    return this.required[fieldName] === false ? 'waiver-input--required' : '';
  }

  inputChanged(e: InputEvent): void {
    const target = e.target as HTMLInputElement;

    if (this.required[target.name] !== undefined) {
      this.$set(this.required, target.name, this.values[target.name].length > 0);
    }

    if (this.waiverIsValid()) {
      this.$set(this.waiver.data, 'fields', this.values);
      this.$store.dispatch('events/waivers/add', {entry_ref: this.entry.data.reference, waiver: this.waiver}).then(() => {
        this.$emit('valid', true);
      });
    } else {
      this.$emit('valid', false);
    }
  }

  waiverIsValid(): boolean {
    let valid = true;
    for (const req of Object.keys(this.required)) {
      if (this.required[req] === false) {
        valid = false;
        break;
      }
    }

    return valid;
  }

  render(createElement: CreateElement): VNode {
    return this.compiledTemplate.render.call(this, createElement);
  }
}
